import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueTippy from 'vue-tippy'

import App from './App.vue'
import { router } from './router'
import { i18n } from './i18n'

import './assets/styles/tokens.css'
import './assets/styles/buttons.css'
import './assets/styles/forms.css'
import 'tippy.js/dist/tippy.css'

// Build provenance in the browser console — same data as /version.json.
if (typeof __GIT_SHA__ !== 'undefined') {
  console.info(
    `Random Vinyl ${__GIT_SHA__}${__GIT_DIRTY__ ? '-dirty' : ''} (built ${__BUILT_AT__})`
  )
}

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(i18n)
// Registers the global `v-tippy` directive used for field-hint tooltips.
app.use(VueTippy)
app.mount('#app')
